import { jsx as _jsx } from "react/jsx-runtime";
import { TouchableOpacity } from "react-native";
import { Text } from "./Text";
import { useTheme } from "../styles";
/**
 * Pressable element that visually looks like a web link and calls an `onPress`
 * callback.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-98}
 */ export function Link(param) {
    var disabled = param.disabled, onPress = param.onPress, style = param.style, testID = param.testID, text = param.text, textAlign = param.textAlign;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(TouchableOpacity, {
        disabled: disabled || !onPress,
        onPress: onPress,
        style: [
            disabled ? {
                opacity: 0.6
            } : null,
            style
        ],
        testID: testID,
        role: "link",
        children: /*#__PURE__*/ _jsx(Text, {
            color: theme.color.gray300,
            text: text,
            textAlign: textAlign,
            size: 14,
            style: {
                lineHeight: 18,
                textDecorationLine: onPress ? 'underline' : undefined
            }
        })
    });
}
